import { useContext, useState } from 'react';
import Cards from '../../../assets/images/carde.png'

// @styles 
import './styles.scss'
import '../small-switch/styles.scss'
import cx from 'classnames';
import CardsAdditional from '../cards-additional';
import { Button, Form, InputNumber, Modal, notification } from 'antd';
import { useEffect } from 'react';
import { formatPrice, getBody, getUrl, getValueField, setFieldsValue } from 'utils/utils';
import Context from 'context/appContext';
import ModalWarning from 'components/modal-warning';
import LoadingProcedure from 'components/loading-procedure';

export default function CardsCoverages({ info, form, current, index }) {
    const [defaultClass, setDefaultClass] = useState('default');
    const [isClassActive, setIsClassActive] = useState(false);
    const [api, contextHolder] = notification.useNotification();
    const [alert, setAlert] = useState(false);
    const [respaldoTerceros, setRespaldoTerceros] = useState([]);
    const [respaldoBienes, setRespaldoBienes] = useState([]);
    const [sectionsExtras, setSectionsExtras] = useState([]);
    const [coveragesExtrasApply, setCoveragesExtrasApply] = useState([]);
    const [coveragesBienesApply, setCoveragesBienesApply] = useState([]);
    const [coveragesTercerosApply, setCoveragesTercerosApply] = useState([]);
    const [sumRespaldoBienes, setSumRespaldoBienes] = useState([]);
    const [tipoCambio, setTipoCambio] = useState({});
    const [maxSumBienes, setMaxSumBienes] = useState(20000000);
    const [monedaId, setMonedaId] = useState('MXN');
    const [dataResponse, setDataResponse] = useState({});
    const [loadingComponent, setLoadingComponent] = useState(true);
    const { dataForm: { data, formResponses }, setDataForm, customRequest, formStatus: { steps, currentStep, currentQuestion }, sidebarData,
        setPriceToShow, setSidebarData, setReturnButton, setDisabledButtonContinue, activeKey, setActiveKey, currency, setCurrency, isActiveAditionals, priceToShow } = useContext(Context);
    const infoAditional = current && current.newItems && current.newItems.find((field) => field && field.key === 'proteccionAdicionalParaTi');
    const regex = /\B(?=(\d{3})+(?!\d))/g;
    const covTerceros = coveragesTercerosApply;
    const isBienes = ['1001', '1030', '4001'];
    const isExtras = ['5101', '5119', '4C10', '4C11', '4C08'];
    const isExtrasNotRender = ['4C10', '4C11', '4C08'];
    const additionals = ['TEV', 'FHM'];
    const modelConfig = data && data.modelConfig ? data.modelConfig : {};
    const messageAdd = "Tu cobertura ha sido agregada con éxito";
    const messageRemove = "Tu cobertura ha sido removida con éxito";

    useEffect(async () => {
        await getRespaldos();
        !priceToShow && await serviceCalculator();
    }, []);

    useEffect(() => {
        setDisabledButtonContinue(loadingComponent);
        setReturnButton(!loadingComponent);
    }, [loadingComponent]);

    // const convert = (value, divisa, monedaId) => {
    //     const valueConverted = divisa > 0 && (monedaId === 'USD' ? value / divisa : value * divisa);
    //     return valueConverted;
    // }

    const serviceCalculator = async () => {
        const bienes = ['1001', '1030', '4001']
        const validateBienes = () => {
            bienes && bienes.forEach(code => {
                const indexField = formResponses.findIndex(x => x.code === code);
                const validate = activeKey[code];
                const field = formResponses[indexField];
                const mandatory = field && field.mandatory;
                if (indexField !== -1 && !validate) {
                    formResponses[indexField]['value'] = mandatory ? form.getFieldValue([field.code]) : 0;
                }
            })
        }
        validateBienes();
        setLoadingComponent(true);
        const valPrimary = steps[currentStep] && steps[currentStep].questions[currentQuestion] && steps[currentStep].questions[currentQuestion].primary;
        const options = valPrimary && valPrimary.opciones_servicio_segundo_plano
            ? valPrimary.opciones_servicio_segundo_plano
            : '';
        const opciones_servicio = options && getUrl(options, formResponses, 'calculator', form);
        await customRequest(opciones_servicio.url, opciones_servicio.header, opciones_servicio.method, null).then((res) => {
            res && res.data && res.data.totalPremium && setPriceToShow(res.data.totalPremium);
        })
            .catch(async (error) => {
                throw new Error(error)
            })
        setLoadingComponent(false);
    }

    useEffect(async () => {
        validateDependency(sectionsExtras, activeKey);
        const IndexActiveK = formResponses.findIndex(x => x.code === 'activeKeys')
        getBody({}, modelConfig, formResponses, [], {});
        getSumaAseguradaBienes();
        IndexActiveK !== -1 && (Object.keys(activeKey).length > 1) && await serviceCalculator();
    }, [activeKey]);

    useEffect(() => { getSumaAseguradaBienes() }, [coveragesBienesApply, respaldoBienes, tipoCambio, formResponses]);

    //Respaldo de Bienes para actualizar maximo y minimo segun la moneda
    useEffect(() => {
        const IndexMonedaId = formResponses.findIndex(x => x.key === 'monedaId')
        IndexMonedaId === -1 && formResponses.push({ key: "monedaId", value: currency ? 'MXN' : 'USD' });
        respaldoBienes && respaldoBienes.max && setMaxSumBienes(Number(currency ? respaldoBienes.max.mxn : respaldoBienes.max.usd));
    }, [respaldoBienes,currency]);

    useEffect(() => {
        const allData = { sectionsExtras: sectionsExtras, sectionsBienes: respaldoBienes, sectionsTerceros: respaldoTerceros };
        setSidebarData(getSidebarData(allData, formResponses));
    }, [coveragesExtrasApply, coveragesBienesApply, coveragesTercerosApply, currency]);

    useEffect(() => {
        const coveragesExtrasSelect = validateDependency(sectionsExtras);
        setCoveragesExtrasApply(coveragesExtrasSelect);
        setCoveragesBienesApply(validateDependency(respaldoBienes && respaldoBienes.sections));
        setCoveragesTercerosApply(validateDependency(respaldoTerceros && respaldoTerceros.sections));
        getSumaAseguradaBienes();
        const allData = { sectionsExtras: sectionsExtras, sectionsBienes: respaldoBienes, sectionsTerceros: respaldoTerceros };

        setSidebarData(getSidebarData(allData, formResponses));

    }, [activeKey, respaldoBienes, respaldoTerceros, sectionsExtras, formResponses, isActiveAditionals, currency]);

    const getActiveKeys = () => {
        let activeKeyMandatory = JSON.parse(JSON.stringify(activeKey));
        let keysInput = [];
        respaldoBienes && respaldoBienes.sections && respaldoBienes.sections.forEach((respaldo, index) => {
            const coverageInput = respaldo && respaldo.coverages && respaldo.coverages.find((coverage) => coverage.input);
            if (coverageInput && coverageInput.mandatory) {
                activeKeyMandatory[coverageInput.code] = true
            }
            coverageInput && keysInput.push(coverageInput.code);
        })
        const cardsKeys = activeKey && activeKey && Object.keys(activeKey);
        keysInput.length && cardsKeys && cardsKeys.forEach(key => {
            const exist = keysInput && keysInput.includes(key);
            if (!exist) {
                activeKeyMandatory[key] = false;
            }
        })
        return activeKeyMandatory;
    }
    useEffect(() => {
        let keysInput = [];
        respaldoBienes && respaldoBienes.sections && respaldoBienes.sections.forEach((respaldo) => {
            const coverageInput = respaldo && respaldo.coverages && respaldo.coverages.find((coverage) => coverage.input);
            coverageInput && coverageInput.mandatory ? setActiveKey({ ...activeKey, [coverageInput.code]: true }) : !activeKey[coverageInput.code] && setActiveKey({ ...activeKey, [coverageInput.code]: false });
            coverageInput && keysInput.push(coverageInput.code)
        })
        const cardsKeys = activeKey && activeKey && Object.keys(activeKey);
        keysInput.length && cardsKeys && cardsKeys.forEach(key => {
            const exist = keysInput && keysInput.includes(key);
            !exist && setActiveKey({ ...activeKey, [key]: false });
        })
    }, [respaldoBienes]);


    const getPrice = (price) => {
        return price && Number(price.toString().replace(/[^0-9]/g, ''));
    }

    const getSublimitOrValue = (coverage) => {
        let sum = 0
        const index = coverage && coverage.index >= 0 && Number(coverage.index)
        const currencyLimit = coverage && coverage.currencyLimit && coverage.currencyLimit[index];
        const bienesMandatory = getActiveKeys();
        currencyLimit && currencyLimit.insuredSumCriteria && currencyLimit.insuredSumCriteria.dependencies
            && currencyLimit.insuredSumCriteria.dependencies.forEach((key) => {
                const coverage = formResponses.find(x => x.code === key);
                const valueCovDependency = isBienes.includes(key) ? activeKey[key] ? coverage && coverage.mandatory && bienesMandatory[key] && form.getFieldValue(key) ? Number(form.getFieldValue(key)) : activeKey[key] ? Number(form.getFieldValue(key)) : 0 :
                    bienesMandatory[key] ? Number(form.getFieldValue(key)) : 0 : Number(form.getFieldValue(key));
                sum = sum + (valueCovDependency >= 0 ? getPrice(Number(valueCovDependency)) : 0);
            })
        const formula = currencyLimit && currencyLimit.insuredSumCriteria && currencyLimit.insuredSumCriteria.formula && currencyLimit.insuredSumCriteria.formula.replace(/[SUM({dependencias})]{19}|[EQ({dependencias})]{18}/g, sum);
        const subLimit = formula && eval(formula);
        let valueField = getPrice(Math.floor(subLimit));
        if (coverage && coverage.code && !coverage.input && getPrice(Math.floor(subLimit)) > 0) {
            valueField = coverage && coverage.typeCoverage && additionals.includes(coverage.typeCoverage) ? isActiveAditionals[coverage.typeCoverage] ? valueField : 0 : valueField;
            setFieldsValue(coverage.code, valueField, coverage, formResponses, form);
        }
        return valueField
    }

    const validateDependency = (sections, activeKeyP) => {
        let array = [];
        sections && sections.forEach((section) => {
            section && section.coverages && section.coverages.forEach((coverage) => {
                const code = coverage && coverage.code
                const index = isExtras.includes(coverage.code) ? 0 : getIndexDependency(coverage, activeKeyP) || 0;
                const type = coverage && coverage.typeCoverage
                const validate = additionals && additionals.includes(type);
                const applyAditionals = type && validate && isActiveAditionals[type];
                const indexField = formResponses.findIndex(x => x.code === coverage.code);
                if (index >= 0 && index !== null && (validate ? applyAditionals : true)) {
                    coverage['index'] = index;
                    const limits = coverage && coverage.currencyLimit && coverage.currencyLimit[Number(index)] // limits **
                    const limitCalculated = getSublimitOrValue(coverage);
                    const limitCurrency = currency ? limits && limits.mxn : limits && limits.usd;
                    const validateSubLimit = limitCalculated && limitCurrency && (limitCalculated <= limitCurrency.max);
                    let subLimit = limitCalculated && limitCurrency && (validateSubLimit ? limitCalculated : limitCurrency.max);
                    if (isExtrasNotRender.includes(code)) {
                        subLimit = coverage.insuredSumDefault
                    }
                    coverage['subLimit'] = validate && !applyAditionals ? 0 : subLimit;
                    if (activeKeyP && indexField === -1 && formResponses[indexField].value === 0 && !form.getFieldValue(coverage.code)) {
                        coverage['value'] = getPrice(coverage.insuredSumDefault);
                        formResponses.push(coverage);
                        // formResponses[indexField].value = getPrice(coverage.insuredSumDefault);
                        form.setFieldsValue({ [coverage.code]: getPrice(Math.floor(coverage.insuredSumDefault)) });
                    } else if (indexField !== -1 && !coverage.input) {
                        formResponses[indexField].subLimit = limits && limits.insuredSumCriteria ? limitCalculated && limitCurrency && (validateSubLimit ? limitCalculated : limitCurrency.max) :
                            getPrice(coverage.insuredSumDefault);
                    } else if (indexField === -1) {
                        formResponses.push(coverage)
                    }
                    array.push(coverage);
                } else {
                    coverage['index'] = null;
                    coverage['value'] = isBienes.includes(code) && activeKey[code] ?
                        coverage.mandatory && !getPrice(form.getFieldValue(coverage.code)) ?
                            getPrice(coverage.insuredSumDefault) : getPrice(form.getFieldValue(coverage.code)) : 0;
                    coverage['subLimit'] = null;
                    if (activeKeyP && indexField !== -1) {
                        formResponses[indexField] = coverage
                        form.setFieldsValue({ [coverage.code]: 0 });
                    } else if (indexField === -1) {
                        formResponses.push(coverage)
                    }
                }
            })
        })
        return array
    }

    const getDefaultValueCov = (field, minUSD) => {
        const defaultValueUSD = !currency ? minUSD : field.insuredSumDefault;
        field['insuredSumDefaultUSD'] = defaultValueUSD;
        return Math.round(defaultValueUSD);
    }

    const getSidebarData = (data, formResponses) => {
        const sidebarData = { title: 'COBERTURAS', items: [] };
        let rows = [];
        let raws = [];
        let rowsTerceros = [];

        if (data && data.sectionsExtras && data.sectionsBienes) {
            const coveragesIncludes = data.sectionsExtras.concat(data.sectionsBienes.sections);
            const allCoveragesApply = coveragesExtrasApply && coveragesExtrasApply.concat(coveragesBienesApply);
            coveragesIncludes && coveragesIncludes.forEach(section => {
                const coverageBasicD = section && section.coverages && section.coverages.find(x => !x.input);
                const fieldNotRender = coverageBasicD && coveragesExtrasApply && coveragesExtrasApply.find(x => !x.input && (x.code === coverageBasicD.code));
                const value = coverageBasicD && form.getFieldValue(coverageBasicD.code)
                const limitCalculated = getSublimitOrValue(coverageBasicD);
                const subLimit = fieldNotRender && fieldNotRender.subLimit ? fieldNotRender.subLimit :
                    limitCalculated ? limitCalculated :
                        fieldNotRender && fieldNotRender.index >= 0 ? fieldNotRender.insuredSumDefault : null;
                (fieldNotRender && !fieldNotRender.input && fieldNotRender.index >= 0) && (value || subLimit) && raws.push({
                    label: section.description,
                    value: formatPrice((value || subLimit))
                })
            });

            allCoveragesApply && allCoveragesApply.forEach(coverage => {
                const value = coverage && form.getFieldValue(coverage.code)
                const limitCalculated = getSublimitOrValue(coverage);
                const subLimit = limitCalculated ? limitCalculated :
                    coverage && coverage.index >= 0 ? coverage.insuredSumDefault : null;
                const indexInArray = raws.findIndex(x => x.label === coverage.description);
                (coverage && !coverage.input && !coverage.typeCoverage && coverage.index >= 0 && indexInArray === -1 && coverage.code !== '4003') && (value || subLimit) && raws.push({
                    label: coverage.description,
                    value: formatPrice((value || subLimit))
                })

            });


            raws && raws.length > 0 && sidebarData.items.push(
                {
                    title: 'Adicionales Incluidas',
                    values: [{
                        rows: raws
                    }]
                }
            )
        }

        if (data && data.sectionsExtras) {

            data.sectionsExtras && data.sectionsExtras.forEach(section => {
                const coverageBasic = section && section.coverages && section.coverages.find(x => x.typeCoverage === 'BAS');
                const fieldNotRender = coveragesExtrasApply && coveragesExtrasApply.find(x => x.input && x.code === coverageBasic.code);
                const value = coverageBasic && form.getFieldValue(coverageBasic.code);
                const limitCalculated = getSublimitOrValue(coverageBasic);
                const subLimit = fieldNotRender && fieldNotRender.subLimit ? fieldNotRender.subLimit :
                    limitCalculated ? limitCalculated :
                        fieldNotRender && fieldNotRender.index >= 0 ? fieldNotRender.insuredSumDefault : null;
                (fieldNotRender && fieldNotRender.index >= 0) && value && rows.push({
                    label: section.description,
                    value: formatPrice((value || subLimit))
                })
            });

            sidebarData.items.push(
                {
                    title: 'Opcionales Seleccionadas',
                    values: [{
                        rows: rows
                    }]
                }
            )
        }

        const covsSidebarTerceros = ['5101', '4C08'];
        if (data && data.sectionsTerceros) {
            const allCoveragesTerceros = data.sectionsTerceros && data.sectionsTerceros.sections && data.sectionsTerceros.sections[0] &&
                data.sectionsTerceros.sections[0].coverages;
            allCoveragesTerceros && allCoveragesTerceros.forEach(coverage => {
                const index = coverage && coverage.index;
                if (index >= 0 && index != null) {
                    let covApply = allCoveragesTerceros && allCoveragesTerceros.find(x => x.code === coverage.code);
                    const value = covApply && covApply.input ? form.getFieldValue(covApply.code) : getSublimitOrValue(coverage);
                    const limitCalculated = getSublimitOrValue(coverage);
                    const subLimit = limitCalculated ? limitCalculated :
                        covApply ? covApply.insuredSumDefault :
                            null;
                    const dependency = covApply?.currencyLimit[0]?.insuredSumCriteria?.dependencies
                    if (dependency && dependency.includes('5101')) {
                        covApply = Number(form.getFieldValue('5101')) === 0 ? null : covApply
                    }
                    coverage['value'] = value || subLimit
                    covApply && !covsSidebarTerceros.includes(covApply.code) && (value || subLimit) && rowsTerceros.push({
                        label: coverage.description,
                        value: formatPrice((value || subLimit))
                    })
                }
            });
            sidebarData.items.push(
                {
                    title: 'Daños a Terceros',
                    values: [{
                        rows: rowsTerceros
                    }]
                }
            )
        }

        sidebarData.items.push(
            {
                title: 'Asistencias Básicas Incluídas',
                values: [{
                    rows: []
                }]
            }
        );
        sidebarData['key'] = 'sidebarData'
        const indexData = formResponses.findIndex(x => x.key === 'sidebarData');
        indexData !== -1 ? formResponses[indexData] = sidebarData : formResponses.push(sidebarData);
        return [sidebarData];
    }

    const getSumaAseguradaBienes = (key, value) => {
        let totalPriceRE = 0
        let fields = [];
        respaldoBienes && respaldoBienes.sections && respaldoBienes.sections.forEach((section) => {
            const field = section && section.coverages && section.coverages.find((x) => x.sumRE);
            field && fields.push(field);
        })
        fields && fields.forEach(field => {
            if (field.mandatory || (field && activeKey[field.code])) {
                const valueField = field.code === key ? getPrice(value) : getPrice(form.getFieldValue(field.code));
                totalPriceRE = Number(totalPriceRE) + Number(valueField);
            }
        })

        setSumRespaldoBienes(Number(totalPriceRE > maxSumBienes ? maxSumBienes : totalPriceRE))
        return Number(totalPriceRE);
    }

    const getRespaldos = async (dataResponse) => {
        setLoadingComponent(true);
        setReturnButton(false);
        setDisabledButtonContinue(true);
        const infoRequest = info && info.values && info.values[0]?.value;
        const opciones_servicio = getUrl(infoRequest, formResponses);
        const resCoverage = dataResponse && dataResponse.data ? dataResponse : await customRequest(opciones_servicio.url, opciones_servicio.headers, opciones_servicio.method, null);
        data['infoCoverages'] = { resCoverage, infoRequest };
        if (await resCoverage && resCoverage.data) {
            console.log(resCoverage);
            setDataResponse(resCoverage);
            const rBienes = resCoverage.data && resCoverage.data.financialSupport.find(respaldo => respaldo['code'] === 'I');
            const rTerceros = resCoverage.data && resCoverage.data.financialSupport.find(respaldo => respaldo['code'] === 'II')
            const rExtras = resCoverage.data && resCoverage.data.extraSupport && resCoverage.data.extraSupport.sections
            setSectionsExtras(rExtras);
            setRespaldoBienes(rBienes);
            setRespaldoTerceros(rTerceros);
            setDisabledButtonContinue(false);
        } else {
            setAlert(false)
        }
        setReturnButton(true);
        !dataResponse && getTipoCambio();
        setLoadingComponent(false);
    }

    const RespaldoBienes = () => {
        const sections = respaldoBienes && respaldoBienes.sections;
        return sections && sections.map((card) => {
            const coverageInput = card && card.coverages && card.coverages.find(coverage => coverage.input === true);
            const limits = coverageInput && coverageInput.currencyLimit[0]; // limits **
            const mandatory = coverageInput && coverageInput.mandatory;
            const limitCurrency = currency ? limits && limits.mxn : limits && limits.usd;
            const defaultValue = coverageInput && limitCurrency && getDefaultValueCov(coverageInput, limitCurrency.min) || coverageInput && coverageInput.insuredSumDefault;
            const codeCoverage = coverageInput && coverageInput.code;
            const active = (mandatory && !activeKey[codeCoverage] && setActiveKey({ ...activeKey, [codeCoverage]: true }) || activeKey[codeCoverage]);
            codeCoverage && !active && setValue(0, coverageInput);
            getSublimitOrValue(coverageInput);
            return coverageInput && (
                card &&
                <div className={cx(
                    'coverages-economy__content-items-card',
                    { 'active-card': (active) }
                )}>
                    <div className='coverages-economy__content-items-card-body'>
                        <div className='coverages-economy__content-items-card-body__header'>
                            <div className='coverages-economy__content-items-card-body__header-detail'>
                                <img className='coverages-economy__content-items-card-body__header-detail__img' src={card && card.render && card.render.img ? card.render.img : Cards} alt={card?.render?.title} onClick={() => !mandatory && onActiveClassCard(codeCoverage, mandatory, coverageInput, defaultValue)} />
                                <div className='coverages-economy__content-items-card-body__header-detail__text' onClick={() => !mandatory && onActiveClassCard(codeCoverage, mandatory, coverageInput, defaultValue)}                    >
                                    <h3 className='coverages-economy__content-items-card-body__header-detail__text-title' >
                                        {card && card.render && card.render.title}
                                    </h3>
                                    <p className='coverages-economy__content-items-card-body__header-detail__text-description'>
                                        {card && card.render && card.render.body}
                                    </p>
                                </div>
                            </div>
                            <div className='coverages-economy__content-items-card-body__header-detail__btn'>
                                <Button className='ant-btn-outline c-2' onClick={() => !mandatory && onActiveClassCard(codeCoverage, mandatory, coverageInput, defaultValue)}>
                                    Agregar
                                </Button>
                                <div className={`coverages-economy__content-items-card-body__header-detail__btn-plus ${mandatory ? 'no-select' : ''}`} onClick={() => !mandatory && onActiveClassCard(codeCoverage, mandatory, coverageInput, defaultValue)} />
                            </div>
                        </div>

                    </div>
                    <div className='coverages-economy__content-items-card-footer__price'>
                        <p className='coverages-economy__content-items-card-footer__price-value'>
                            <Form.Item onClick={() => { }}>
                                <Form.Item name={codeCoverage} onClick={() => { }}>
                                    <InputNumber
                                        id={codeCoverage}
                                        //max={limitCurrency.max}
                                        min={value => value != 0 ? limitCurrency.min : 0}
                                        maxLength={21}
                                        formatter={value => `${value}`.replace(/[^0-9]/g, '').replace(regex, ',')}
                                        defaultValue={getDefaultValue(coverageInput, defaultValue)}
                                        onBlur={(e) => {
                                            onBlur(e, coverageInput, maxSumBienes, limitCurrency)
                                        }}
                                        onChange={(e) => { onChange(e, codeCoverage, coverageInput, limitCurrency) }}
                                        autoComplete="off"
                                        required={coverageInput.mandatory}
                                    />
                                </Form.Item>
                                <span className="suffix">{currency ? 'MXN' : 'USD'}</span>
                            </Form.Item>
                        </p>
                        <div className='coverages-economy__content-items-card-footer__price-text'>
                            <strong>SUMA ASEGURADA</strong>
                            <p>MÍNIMO: {formatPrice(limitCurrency.min)}</p>
                        </div>
                    </div>

                </div>
            )

        }
        )
    }

    const getIndexDependency = (coverage, activeKeyP) => {
        const currencyLimit = coverage && coverage.currencyLimit
        let indexPrioridad = null; let index = null; let render = false; let arrayV = []; let indexs = []; let caseExclude = false; let caseNotDependency = null;
        currencyLimit && currencyLimit.forEach((element, indexE) => {
            let array = [];
            let validaciones = [];
            const dependency = element && element.insuredSumCriteria && element.insuredSumCriteria.dependencies;
            const insuredSumCriteria = element && element.insuredSumCriteria && element.insuredSumCriteria;
            caseNotDependency = !insuredSumCriteria ? indexE : null
            dependency && dependency.forEach((coverageKey) => {
                if (activeKeyP) {
                    activeKeyP[coverageKey] && array.push(true);
                } else {
                    activeKey && activeKey[coverageKey] && array.push(true)
                    const activeKeysTerceros = covTerceros && covTerceros[0] && covTerceros[0].code;
                    coverageKey && (coverageKey === activeKeysTerceros) && array.push(true)
                    caseExclude = (coverageKey && activeKeysTerceros && insuredSumCriteria && (coverageKey === activeKeysTerceros)) ? indexE : caseExclude;
                    if (caseExclude >= 0) {
                        coverage['index'] = indexE
                    }
                }
            })

            if (!dependency && !coverage.typeCoverage) {
                caseExclude = indexE
                coverage['index'] = indexE
            }

            validaciones = array && array.map(x => x === true)
            render = (currencyLimit && validaciones && validaciones.length) === (dependency && dependency.length);
            index = render ? indexE : index
            render && currencyLimit.length > 1 && arrayV.push({ [indexE]: validaciones.length })

            currencyLimit.length > 1 && arrayV && arrayV.forEach((indexLenght, i) => {
                indexs.push(index)
                indexPrioridad = (indexLenght[index] > (arrayV[i - 1] && arrayV[i - 1][indexs[i - 1]]))
                    ? index : indexs[i - 1]
            })
        })
        return indexPrioridad >= 0 && indexPrioridad !== null && indexPrioridad !== undefined ? indexPrioridad : caseNotDependency || (caseExclude >= 0 ? caseExclude : false) || index
    }

    const coveragesOptionals = () => {
        return sectionsExtras && sectionsExtras.map((card) => {
            const coverageInput = card && card.coverages && card.coverages.find((coverage) => coverage.input);
            const covApply = coverageInput && coveragesExtrasApply && coveragesExtrasApply.find((x) => x.code === coverageInput.code);
            const index = covApply && covApply.index;
            const limits = coverageInput && coverageInput.currencyLimit && coverageInput.currencyLimit[index >= 0 ? (Number(index)) || 0 : 0] // limits **
            // const limitCalculated = covApply && covApply.subLimit
            const limitCalculated = getSublimitOrValue(coverageInput);
            const limitCurrency = currency ? limits && limits.mxn : limits && limits.usd;
            // const maxValue = limitCalculated && limitCalculated <= limitCurrency.min ? limitCurrency.min : limitCalculated;
            const maxValue = limitCurrency && ((limitCalculated && limitCalculated < limitCurrency.min) ? limitCurrency.min : (limitCalculated > limitCurrency.max) ? limitCurrency.max : limitCalculated);
            const minValue = limitCurrency && limitCurrency.min;
            const defaultV = coverageInput && getDefaultValueCov(coverageInput);
            const codeCoverage = coverageInput && coverageInput.code;
            const defaultValue = defaultV > maxValue ? maxValue : defaultV;
            if (!maxValue && covApply) {
                setFieldsValue(coverageInput.code, 0, coverageInput, formResponses, form);
            }
            return (limits && covApply && maxValue !== 0 && <div className='coverages-economy__content-additionalcards'>
                <div className='coverages-economy__content-additionalcards__item'>
                    <img className='coverages-economy__content-additionalcards__item-img' src={card && card.render && card.render.img ? card.render.img : Cards} alt={card?.render?.title} />
                    <div className='coverages-economy__content-additionalcards__item-text'>
                        <strong>{card && card.render && card.render.title}</strong>
                        <p>{card && card.render && card.render.body}</p>
                    </div>
                    <div className='coverages-economy__content-additionalcards__item-price'>
                        <p className='coverages-economy__content-additionalcards__item-price-value'>
                            <Form.Item >
                                <Form.Item name={codeCoverage}>
                                    <InputNumber
                                        id={codeCoverage}
                                        min={value => value != 0 ? limitCurrency.min : 0}
                                        max={maxValue}
                                        maxLength={21}
                                        formatter={value => `${value}`.replace(regex, ',').replace('.', '')}
                                        defaultValue={getDefaultValueOptionals(covApply, minValue, limitCurrency, minValue)}
                                        onBlur={(e) => {
                                            onBlur(e, covApply, null, { max: maxValue })
                                        }}
                                        onChange={(e) => {
                                            onChange(e, codeCoverage, covApply, { max: maxValue, min: limitCurrency.min })
                                        }}
                                        autoComplete="off"
                                    />
                                </Form.Item>
                                <span className="suffix">{currency ? 'MXN' : 'USD'}</span>
                            </Form.Item>
                        </p>
                        <div className='coverages-economy__content-additionalcards__item-price-description'>
                            <strong>SUMA ASEGURADA</strong>
                            <div className='coverages-economy__content-additionalcards__item-price-description-range'>
                                <p>MÍNIMO: {formatPrice(limitCurrency.min)}</p>
                                <p>MÁXIMO: {formatPrice(maxValue)}</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>)
        })
    }

    const getDefaultValueOptionals = (coverage, defaultValue, limitCurrency, minValue) => {
        if (coverage && coverage.code) {
            const indexC = formResponses.findIndex(x => x.code === coverage.code);
            const value = form.getFieldValue(coverage.code);
            coverage['insuredSumDefault'] = defaultValue;

            if (indexC === -1) {
                setFieldsValue(coverage.code, defaultValue, coverage, formResponses, form);
            } else if (value === undefined || value === null || value !== 0 && (getPrice(value) < defaultValue) || value === 0 && !formResponses[indexC].noSelectInput) {
                setFieldsValue(coverage.code, defaultValue, coverage, formResponses, form);
            } else if (value === 0 && formResponses[indexC].noSelectInput) {
                setFieldsValue(coverage.code, 0, coverage, formResponses, form);
            }
        }
    }

    const RespaldoTerceros = () => {
        const sections = respaldoTerceros && respaldoTerceros.sections
        return (<>
            <div className='coverages-economy__title'>
                <p>Respaldo económico para daños a terceros</p>
            </div>
            {sections && sections.map((card) => {
                const coverageInput = card && card.coverages && card.coverages.find(coverage => coverage.input);
                const limits = coverageInput && coverageInput.currencyLimit[0]; // limits **
                const defaultV = coverageInput && getDefaultValueCov(coverageInput) || coverageInput && coverageInput.insuredSumDefault;
                const limitCurrency = currency ? limits && limits.mxn : limits && limits.usd;
                const codeCoverage = coverageInput && coverageInput.code;
                const limitCalculated = getSublimitOrValue(coverageInput);
                const minValue = limitCurrency && limitCurrency.min;
                const maxValue = (limitCalculated && limitCalculated < limitCurrency.min) ? limitCurrency.min : (limitCalculated > limitCurrency.max) ? limitCurrency.max : limitCalculated;
                const defaultValue = defaultV > maxValue ? maxValue : defaultV;
                return coverageInput && (
                    <div className='coverages-economy__content-additionalcards'>
                        <div className='coverages-economy__content-additionalcards__item'>
                            <img className='coverages-economy__content-additionalcards__item-img' src={card && card.render && card.render.img ? card.render.img : Cards} alt={card?.render?.title} />
                            <div className='coverages-economy__content-additionalcards__item-text'>
                                <strong>{card && card.render && card.render.title}</strong>
                                <p>
                                    {card && card.render && card.render.body}
                                </p>
                            </div>
                            <div className='coverages-economy__content-additionalcards__item-price'>
                                <p className='coverages-economy__content-additionalcards__item-price-value'>
                                    <Form.Item>
                                        <Form.Item name={codeCoverage} >
                                            <InputNumber
                                                id={codeCoverage}
                                                min={value => value != 0 ? limitCurrency.min : 0}
                                                max={maxValue}
                                                formatter={value => `${value}`.replace(regex, ',')}
                                                defaultValue={getDefaultValueOptionals(coverageInput, minValue, limitCurrency)}
                                                onBlur={(e) => { onBlur(e, coverageInput, null, { max: maxValue, min: limitCurrency.min }) }}
                                                onChange={(e) => { onChange(e, codeCoverage, coverageInput) }}
                                                autoComplete="off"
                                                maxLength={21}
                                            />
                                        </Form.Item>
                                        <span className="suffix">{currency ? 'MXN' : 'USD'}</span>
                                    </Form.Item>
                                </p>
                                <div className='coverages-economy__content-additionalcards__item-price-description'>
                                    <strong>SUMA ASEGURADA</strong>
                                    <div className='coverages-economy__content-additionalcards__item-price-description-range'>
                                        <p>MÍNIMO: {formatPrice(limitCurrency.min)}</p>
                                        <p>MÁXIMO: {formatPrice(maxValue)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                )
            }
            )}
        </>
        )

    }


    const configModal = (message, btnOk, title) => {
        Modal.info({
            icon: '',
            title: title,
            className: 'modal-confirm',
            closable: false,
            okButtonProps: {
                className: 'ant-btn-solid c-2 ant-btn-size-xs margin-s'
            },
            okText: btnOk,
            content: <p>{message}</p>,
            onOk() { }
        });
    }

    const onActiveClassCard = async (key, mandatory, coverageInput, defaultValue) => {
        const codeCoverage = coverageInput && coverageInput.code;
        const select = activeKey && activeKey[codeCoverage];
        let value = defaultValue
        const index = formResponses.findIndex(x => x.code === codeCoverage);
        if (!select && !mandatory && maxSumBienes) {
            const sumaAsegurada = getSumaAseguradaBienes(codeCoverage, value);
            const validateSum = sumaAsegurada < maxSumBienes;
            if (validateSum) {
                setSumRespaldoBienes(sumaAsegurada);
            } else if (sumaAsegurada !== maxSumBienes) {
                const diff = value - (sumaAsegurada - maxSumBienes);
                setSumRespaldoBienes(getSumaAseguradaBienes(codeCoverage, diff));
                value = diff
                form.setFieldsValue({ [codeCoverage]: Math.floor(value) });
            } else if ((!activeKey[codeCoverage] && sumaAsegurada >= maxSumBienes) || activeKey[codeCoverage]) {
                configModal('Para agregar una cobertura adicional vigila que la suma del respaldo económico de bienes, este dentro del máximo permitido.', 'Aceptar', 'Máximo valor superado...')
                value = 0
                setSumRespaldoBienes(getSumaAseguradaBienes(codeCoverage, value));
                form.setFieldsValue({ [codeCoverage]: Math.floor(value) });
            }
        }
        select && setFieldsValue(key, 0, null, formResponses, form);
        coverageInput['value'] = value;
        index !== -1 ? formResponses[index].value = value : formResponses.push(coverageInput);
        form.setFieldsValue({ [codeCoverage]: Math.floor(value) });

        if (!mandatory && value !== 0) {
            const keyActiveK = 'activeKeys';
            const copyActiveKey = JSON.parse(JSON.stringify(activeKey));
            setActiveKey({ ...activeKey, [key]: !select });
            const indexActiveKey = formResponses.findIndex(x => x.code === keyActiveK);
            indexActiveKey !== -1 ? formResponses[indexActiveKey].value = { ...copyActiveKey, [key]: !select } : formResponses.push({ code: keyActiveK, value: { ...copyActiveKey, [key]: !select } });
        }
        !mandatory && await contextHolder && openNotification(!select);
    }

    const resetCoverages = async (financialSupportPack, monedaId) => {
        const newFormResponse = formResponses.filter(x => !x.code);
        setActiveKey({});
        setDataForm(dataForm => ({ ...dataForm, formResponses: newFormResponse }));
        await getRespaldos(financialSupportPack, monedaId);
        await serviceCalculator();
        const allData = { sectionsExtras: sectionsExtras, sectionsBienes: respaldoBienes, sectionsTerceros: respaldoTerceros };
        setSidebarData(getSidebarData(allData, formResponses));
    }

    const onClick = async (monedaId) => {
        const IndexMonedaId = formResponses.findIndex(x => x.key === 'monedaId');
        const currencyClick = monedaId === 'USD' ? false : true;
        IndexMonedaId !== -1 ? formResponses[IndexMonedaId].value = monedaId :
            formResponses.push({ key: "monedaId", value: monedaId });
        setDefaultClass('active-btn-left');
        setCurrency(currencyClick);
        setIsClassActive({ ...isClassActive, [index]: !currencyClick, [0]: currencyClick });
        setMonedaId(monedaId);
        resetCoverages(dataResponse, monedaId);
        const coveragesExtrasSelect = validateDependency(sectionsExtras);
        setCoveragesExtrasApply(coveragesExtrasSelect);
        setCoveragesBienesApply(validateDependency(respaldoBienes && respaldoBienes.sections));
        setCoveragesTercerosApply(validateDependency(respaldoTerceros && respaldoTerceros.sections));
        getSumaAseguradaBienes();
        await contextHolder && openNotification(true, `Se ha aplicado la configuración predefinida para ${monedaId}`);
    }

    const getTipoCambio = async () => {
        const field = current && current.newItems && current.newItems.find((service) => service.key === 'tipoCambio');
        const infoRequest = JSON.parse(field && field.values[0] && field.values[0]?.value)
        const infoTipoCambio = await customRequest(infoRequest.url, infoRequest.headers, infoRequest.method);
        setTipoCambio(infoTipoCambio);
    }

    const getDefaultValue = (coverage, defaultValue, limitCurrency, minValue) => {
        const codeCoverage = coverage && coverage.code;
        const index = formResponses.findIndex(x => x.code === codeCoverage);
        const valuePersisted = index !== -1 && formResponses[index].value;
        let value = form.getFieldValue(codeCoverage);
        const isBienes = ['1001', '1030', '4001'].includes(codeCoverage);
        const isBienesNotSelect = isBienes && (coverage.mandatory ? false : !activeKey[codeCoverage]);
        value = isBienesNotSelect ? 0 : value;
        const defaultValueMin = minValue ? getPrice(defaultValue) < getPrice(minValue) ? getPrice(minValue) : getPrice(defaultValue) : getPrice(defaultValue);
        if (isBienesNotSelect) {
            coverage['value'] = 0
            form.setFieldsValue({ [codeCoverage]: 0 });
            index !== -1 ? formResponses[index].value = value : formResponses.push(coverage);
        }
        if (!isBienesNotSelect && index === -1) {
            value = getPrice(defaultValue) < minValue ? minValue : getPrice(defaultValue);
            coverage['value'] = value;
            form.setFieldsValue({ [codeCoverage]: value });
            formResponses.push(coverage);
        } else if ((!isBienesNotSelect && value === 0) || (coverage.mandatory && index !== -1 && value === 0)) {
            value = coverage.mandatory ? defaultValueMin : defaultValueMin || valuePersisted;
            formResponses[index].value = Math.floor(getPrice(value));
            form.setFieldsValue({ [codeCoverage]: Math.floor(getPrice(value)) });
        }
        if (limitCurrency && limitCurrency.max) {
            if (form.getFieldValue(codeCoverage) > limitCurrency.max) {
                form.setFieldsValue({ [codeCoverage]: Math.floor(getPrice(limitCurrency.max)) });
            }
        }
    }

    const onChange = (e, codeCoverage, coverageInput, limitCurrency) => {
    }

    const calculateValueBienes = (coverage, value, limitCurrency) => {
        const code = coverage && coverage.code;
        const sumaAsegurada = getSumaAseguradaBienes(code, value);
        const validateSum = sumaAsegurada <= maxSumBienes;
        const maxValue = maxSumBienes - sumaAsegurada;
        if (validateSum) {
            setSumRespaldoBienes(sumaAsegurada);
            limitCurrency.max = value + maxValue
        } else if (sumaAsegurada > maxSumBienes) {
            let diff = sumaAsegurada - value <= maxSumBienes ? sumaAsegurada - value : 0;
            const sum = getSumaAseguradaBienes(code, diff);
            const maxV = maxSumBienes - sum;

            limitCurrency.max = diff + maxV
            value = diff + maxV
            setSumRespaldoBienes(getSumaAseguradaBienes(code, value));
        }
        return value;
    }

    const onBlur = (e, coverageInput, maxSumBienes, limitCurrency) => {
        let value = Number(getPrice(e && e.target && e.target.value));
        const minValue = limitCurrency && limitCurrency.min;
        const codeCoverage = coverageInput && coverageInput.code;
        const indexF = formResponses.findIndex(x => x.code === coverageInput.code);
        const maxvalue = limitCurrency && limitCurrency.max;
        value = value >= maxvalue ? maxvalue : value <= minValue ? minValue : value;
        if (maxSumBienes) {
            value = calculateValueBienes(coverageInput, value, limitCurrency)
        }
        if (e && e.target && e.target.value === '0') {
            value = 0
            coverageInput['noSelectInput'] = true
        } else {
            coverageInput['noSelectInput'] = false
        }
        coverageInput['value'] = value;
        indexF !== -1 ? formResponses[indexF] = coverageInput : formResponses.push(coverageInput);
        form.setFieldsValue({ [codeCoverage]: Math.floor(value) });
        const coveragesExtrasSelect = validateDependency(sectionsExtras);
        setCoveragesExtrasApply(coveragesExtrasSelect);
        getSumaAseguradaBienes();

        if (codeCoverage === '1030') {
            const optionalsApply = coveragesExtrasApply && coveragesExtrasApply.filter(x => x.input);
            optionalsApply && optionalsApply.forEach((coverageOptional) => {
                if (coverageOptional && coverageOptional.code) {
                    const indexForm = formResponses.findIndex(x => x.code === coverageOptional.code);
                    const indexLimit = coverageOptional && coverageOptional.index
                    const limits = coverageOptional && coverageOptional.currencyLimit && coverageOptional.currencyLimit[indexLimit];
                    const limitCalculated = getSublimitOrValue(coverageOptional);
                    const limitCurrency = limits && currency ? limits.mxn : limits.usd;
                    const validateSubLimit = limitCalculated && limitCurrency && (limitCalculated <= limitCurrency.max);
                    const subLimit = getPrice(limitCalculated && limitCurrency && (validateSubLimit ? limitCalculated : limitCurrency.max));
                    const valueCovDependency = value;
                    const valueOptional = Math.floor(valueCovDependency && valueCovDependency * 0.5);
                    const valueF = (limitCurrency.min < valueOptional) && (valueOptional < subLimit) ? valueOptional :
                        (limitCurrency.min <= subLimit) && (subLimit <= limitCurrency.max) ? subLimit : limitCurrency.min;
                    form.setFieldsValue({ [coverageOptional.code]: Math.floor(valueF) });
                    coverageOptional['value'] = valueF;
                    indexForm !== -1 ? formResponses[indexForm].value = valueF : formResponses.push(coverageOptional);
                }
            })
            validateDependency(sectionsExtras)
        }
        getSumaAseguradaBienes();
        serviceCalculator();
    }

    const openNotification = (choosed, messageChange) => {
        if (choosed) {
            openNotificationWithIcon("success", messageChange || messageAdd);
        } else {
            openNotificationWithIcon("error", messageRemove);
        }
    };

    const openNotificationWithIcon = (type, description) => {
        api[type]({
            message: ``,
            description,
            style: getNotificationStyle(type),
        });
    };

    const getNotificationStyle = (type) => {
        return {
            success: {
                color: "#707070",
                backgroundColor: "#FFF",
                borderTopRightRadius: "14px",
                borderTopLeftRadius: "14px",
                borderBottomLeftRadius: "14px",
                borderBottomRightRadius: "14px",
                fontFamily: "Arial",
                fontSize: "16px",
            },
            error: {
                color: "#707070",
                backgroundColor: "#FFF",
                borderTopRightRadius: "14px",
                borderTopLeftRadius: "14px",
                borderBottomLeftRadius: "14px",
                borderBottomRightRadius: "14px",
                fontFamily: "Arial",
                fontSize: "16px",
            },
        }[type];
    };

    const setValue = (value, coverage) => {
        const indexF = formResponses.findIndex(x => x.code === coverage.code);
        coverage.value = value ? Number(value) : 0;
        indexF !== -1 ? formResponses[indexF].value = value : formResponses.push(coverage);
        form.setFieldsValue({ [coverage.code]: value })
    }

    return (alert ? <ModalWarning info={{ visible: true, type: 'error' }} /> : (
        <>
            {contextHolder}
            {loadingComponent && (<LoadingProcedure message={'Cotizando'} />)}
            <div className='coverages-economy'>
                <div className='coverages-economy__title'>
                    <p>Respaldo Económico de Bienes</p>
                    <div className='smallswitch__container' id={index}>
                        <div className='smallswitch__container__buttons' id={index}>
                            <button className={`smallswitch__container__buttons-btn ${currency && defaultClass}`}
                                disabled={currency}
                                onClick={(e) => e.detail !== 0 && onClick('MXN')}>
                                <span>MXN</span>
                            </button>
                            <button className={`smallswitch__container__buttons-btn ${!currency ? 'active-btn-right' : ''}`}
                                disabled={!currency}
                                onClick={(e) => e.detail !== 0 && onClick('USD')}>
                                <span>USD</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className='coverages-economy__content'>
                    <div className='coverages-economy__content-items'>
                        {RespaldoBienes()}
                    </div>
                    {coveragesOptionals()}
                    <div className='coverages-economy__content-totalprice'>
                        <div className='coverages-economy__content-totalprice__item'>
                            <p className='coverages-economy__content-totalprice__item-value'><strong>{formatPrice(sumRespaldoBienes)}</strong> {currency ? 'MXN' : 'USD'}</p>
                            <div className='coverages-economy__content-totalprice__item-text'>
                                <strong>RESPALDO ECONÓMICO DE BIENES</strong>
                                <p>Máximo 20,000,000 MXN y si son USD, su equivalente</p>
                            </div>
                        </div>
                    </div>
                    {RespaldoTerceros()}
                </div>
                <CardsAdditional info={infoAditional} form={form} openNotification={openNotification} current={current} index={Math.random()} />
            </div>
        </>
    )
    )
}